import axios from '../utils/axios'

// 获取用户订单列表
export function getOrderList(data) {
    return axios({
        url: '/api/web/v1/order/list',
        method: 'get',
        params: data
    })
}
// 查询套餐列表
export function getPlanList(data) {
    return axios({
        url: '/api/web/v1/order/goods/list',
        method: 'get',
        params: data
    })
}
// 创建订单
export function createOrder(data) {
    return axios({
        url: '/api/web/v1/order/create',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    })
}
// 取消订单
export function cancelOrder(data) {
    return axios({
        url: '/api/web/v1/order/cancel',
        method: 'post',
        data: data
    })
}
//获取订单token
export function getOrderToken(data) {
    return axios({
        url: '/api/web/v1/order/token',
        method: 'get',
        params: data
    })
}
// 获取订单详情（用于刷新二维码）
export function getOrderDetail(data) {
    return axios({
        url: '/api/web/v1/order/get',
        method: 'get',
        params: data
    })
}
// 获取渠道交易token
export function getChannelToken(data) {
    return axios({
        url: '/api/web/v1/order/channel/token',
        method: 'get',
        params: data
    })
}
// 发起渠道支付交易
export function createChannelOrder(data) {
    return axios({
        url: '/api/web/v1/order/channel/create',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    })
}